import React from 'react'
import Navbar from '../components/shared/Navbar'
import SelectPresentationType from '../components/presentation-type/SelectPresentationType'

const PresentationTypePage: React.FC = () => {
  return (
    <div className="h-screen overflow-hidden">
      <Navbar />
      <SelectPresentationType />
    </div>
  )
}

export default PresentationTypePage
